import { createAsyncThunk } from '@reduxjs/toolkit';
import { set } from 'lodash';
import { client } from '../../../api';

export const fetchFundingGroupsThunk = createAsyncThunk('fundingGroups.fetchList', async (payload, { rejectWithValue }) => {
  try {
    const { data, status, statusText } = await client.get('/funding');
    return { ...data, status, statusText };
  } catch (err) {
    const { data, status, statusText } = err.response;
    return rejectWithValue({ ...data, status, statusText });
  }
});

export const fetchFundingGroupsReducers = {
  [fetchFundingGroupsThunk.fulfilled]: (state, { payload }) => {
    set(
      state,
      'response',
      payload,
    );
    set(
      state,
      'isLoading',
      false,
    );
  },
  [fetchFundingGroupsThunk.pending]: (state) => {
    set(
      state,
      'isLoading',
      true,
    );
  },
  [fetchFundingGroupsThunk.rejected]: (state, { payload }) => {
    set(
      state,
      'error',
      payload,
    );
    set(
      state,
      'isLoading',
      false,
    );
  },
};
